import { styled } from "styled-components";

export const ServersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;
